export enum LineItemsState {
  NotCompleted,
  InProgress,
  Skipped,
  Completed,
}
